import { TextHelper } from 'src/app/utils/text-helper';
import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { SubmitButtonShared } from '../../general/shared/submit-button-shared';
import { ProgressNavShared } from '../../general/shared/progress-nav-shared';
import { RegisterShared } from '../../general/shared/register-shared';
import { Subscription } from 'rxjs';
import { UserApiService } from 'src/app/data/repository/user-repository/user-api.service';
import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { mainUrl } from 'src/app/global-variables';
import { AuthenticationAnalyticsService } from 'src/app/data/repository/analytics-repository/authentication-analytics.service';
import { MetrixService } from 'src/app/data/repository/analytics-repository/metrix.service';
import { CheckMetrixService } from 'src/app/data/repository/checkMetrix/checkMetrix.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
  phoneNumber: string;
  currentStep = 1;
  totalSteps = 5;
  buttonTitle = 'ادامه';
  buttonActivationStatus = [0, 0, 0, 0, 0, 1];

  returnUrl: string;

  showLoading = false;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;

  constructor(
    private route: ActivatedRoute,
    private userDataService: UserDataService,
    private registerShared: RegisterShared,
    private submitButtonShared: SubmitButtonShared,
    private progressNavShared: ProgressNavShared,
    private userApiService: UserApiService,
    private snackBarService: SnackBarService,
    private router: Router,
    private authAnalytics: AuthenticationAnalyticsService,
    private routeAnimationShared: RouteAnimationShared,
    private textHelper: TextHelper,
    private metrixService: MetrixService,
    private CheckMetrixService: CheckMetrixService
  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');

    // this.phoneNumber = this.route.snapshot.paramMap.get('phoneNumber');
    this.subscription1 = this.registerShared.nextPageObs$.subscribe(
      (clicked) => {
        if (clicked) {
          this.nextPage();
        }
      }
    );
    this.subscription2 =
      this.progressNavShared.progressNavPreStepObs$.subscribe((clicked) => {
        if (clicked) {
          this.previousPage();
        }
      });
    this.subscription3 =
      this.registerShared.registerActivateButtonObs$.subscribe((id) => {
        if (id !== -1) {
          this.buttonActivationStatus[id] = 1;
        }
      });
    this.subscription4 =
      this.registerShared.registerDeactivateButtonObs$.subscribe((id) => {
        if (id !== -1) {
          this.buttonActivationStatus[id] = 0;
        }
      });
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
  }

  nextPage() {
    if (this.currentStep < this.totalSteps) {
      this.submitButtonShared.activateNextButton(false);
      if (this.currentStep === 1) {
        // this.submitButtonShared.animateDownButton();
      } else if (this.currentStep === 2) {
        this.progressNavShared.progressNavShowBackButton();
        // this.submitButtonShared.animateUpButton();
      } else if (this.currentStep === 5) {
        this.buttonTitle = 'ورود به برنامه';
      }
      if (this.buttonActivationStatus[this.currentStep] === 1) {
        this.submitButtonShared.activateNextButton(true);
      }
      this.animatePages(
        (this.currentStep + 1).toString() + 'Page',
        this.currentStep.toString() + 'Page',
        true
      );
      this.currentStep++;
    } else {
      this.showLoading = true;
      this.userApiService.registerUser().then(async (res) => {
        if (res.isSuccess()) {
          this.userDataService.getUser().then((res) => {
            this.metrixService.metrix.sendEvent('zswgd', {
              _id: res._id,
            });
          });

          this.authAnalytics.analyticAuthenticationRegisterCompleted();
          if (!localStorage.getItem('no-need-intro')) {
            localStorage.setItem('no-need-intro', '1');
          }
          const result = await this.userApiService.getPromotionUser();
          this.routeAnimationShared.showRouteAnimation();
          this.CheckMetrixService.checkMetrix();
          if (result.isSuccess()) {
            // if (this.returnUrl) {
            //   this.router.navigate(['/promotion'], {
            //     queryParams: { returnUrl: this.returnUrl },
            //   });
            // } else {
            //   this.router.navigate(['/promotion']);
            // }
            localStorage.setItem('show-promotion', 'true');
            const url = this.textHelper.replaceDeeplinkToCorrectUrls(
              this.returnUrl
            );

            if (url) {
              this.router.navigate([url]);
            } else {
              this.router.navigate([mainUrl]);
            }
          } else {
            const url = this.textHelper.replaceDeeplinkToCorrectUrls(
              this.returnUrl
            );
            if (url) {
              this.router.navigate([url]);
            } else {
              this.router.navigate([mainUrl]);
            }
          }
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.showLoading = false;
      });
    }
  }

  previousPage() {
    if (this.currentStep === 1) {
      this.router.navigate(['/authentication1']);
    } else if (this.currentStep === 2) {
      this.progressNavShared.progressNavHideBackButton();
      // this.submitButtonShared.animateUpButton();
    } else if (this.currentStep === 3) {
      // this.submitButtonShared.animateDownButton();
    } else if (this.currentStep === 6) {
      this.buttonTitle = 'مرحله بعد';
    }
    if (this.currentStep > 1) {
      this.animatePages(
        (this.currentStep - 1).toString() + 'Page',
        this.currentStep.toString() + 'Page',
        false
      );
      this.currentStep--;
      this.submitButtonShared.activateNextButton(true);
    }
  }

  animatePages(enter: string, leave: string, isForward: boolean) {
    if (isForward) {
      document.getElementById(leave).style.right = '-100%';
    } else {
      document.getElementById(leave).style.right = '100%';
    }
    document.getElementById(enter).style.right = '0%';
  }
}
